import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaCheckCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next'; 

const DisassembleTiles = ({ currentData, sortedDisassembleData, handleTransferClick, handleReceiptClick }) => {
  const { DisassembleData, DisassembleRecipt, loading, error } = useSelector((state) => state.Disassemble);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const hasReceipt = Array.isArray(currentData) && currentData.some(item => item.count > 0);
  
  // useEffect(() => {
  //   if (!DisassembleData || DisassembleData.length === 0) {
  //     dispatch(GetDisassembleInput());
  //   }
  // }, [DisassembleData, dispatch]);

  // const validDisassembleData = Array.isArray(DisassembleData) ? DisassembleData : [];
  // // Sort DisassembleData so that items with count > 0 come first
  // const sortedDisassembleData = [...validDisassembleData].sort((a, b) => {
  //   if (a.count > 0 && b.count <= 0) return -1;
  //   if (a.count <= 0 && b.count > 0) return 1;
  //   // Now, prioritize items with receiptQty >= plannedQty by moving them to the end
  //   if (a.receiptQty >= a.plannedQty && b.receiptQty < b.plannedQty) return 1;
  //   if (a.receiptQty < a.plannedQty && b.receiptQty >= b.plannedQty) return -1;

  //   return 0;
  // });
  return (
    <div className="disassemble-tiles-main">
      {sortedDisassembleData && sortedDisassembleData.length === 0 ? (
        <div>No Data Available</div>
      ) : (
        currentData.map((item, index) => (
          <div
            className={`disassemble-tiles ${item.receiptQty >= item.plannedQty ? "" : item.count > 0 ? "green-border" : ""}`}
            key={index}
          >
            <div className="d-flex gap-3 gap-xxl-2 ">
              <div className="disassemble-tiles-text">
              <p>{t('Order No')}</p>  
                <p>{t('Item Code')}</p>
                {/* <p>{t('No of Coils')}</p> */}
                <p>{t('Remaining Qty')}</p>
              </div>
              <div className="query-data">
                <p>{item.disassemble_No} - {item.order_Date}</p>
                <p style={{ letterSpacing: "0.1em" }}>
                  {`${item.item_Code} - C: ${item.no_Of_Coils}`}
                </p>

                {/* <p>{item.no_Of_Coils}</p> */}
                <p>{(item.plannedQty - item.receiptQty).toLocaleString()}</p>
              </div>
            </div>
            <div className="inline-data">
              <p>{t('Transferred')}</p> <p><strong>{item.transfered_Count}</strong></p>
              <p>{t('Receipt Count')}</p> <p><strong>{item.receipt_Count}</strong></p>
            </div>
            <div className="d-flex gap-4 align-items-start">
              <div
                className="disassemble-tiles-text"
                style={{ flexShrink: 0, whiteSpace: "nowrap" }}
              >
                <p>{t("Items Cuts")}</p>
              </div>
              <div className="querys1-data" style={{ flex:1 }}>
                <p style={{ margin: 0 }}>
                  {item.item_To_Cut
                    .replace(/\s*,?\s*SLIT SCRAP\s*,?\s*/i, "")
                    // .replace(/\s+/g, "")
               }
                </p>
              </div>
            </div>
            {/* Completed Sticker */}
            {item.receiptQty >= item.plannedQty && (
              <div className="completed-sticker">
                <p className="completed-colour">Completed <span><FaCheckCircle /></span></p>
              </div>
            )}
            <div className="disassemble-tiles-btn">
              {item.count > 0 ? (
                <button
                  className="button xs"
                  onClick={() => handleReceiptClick(item)}
                >
                  {t("Receipt")}
                </button>
              ) : !hasReceipt && item.count === 0 && item.no_Of_Coils > item.transfered_Count ? (
                <button
                  className="button xs"
                  onClick={() => handleTransferClick(item)}
                >
                  {t("Transfer")}
                </button>
              ) : null}
              
              {/* // :!hasReceipt&&item.count===0 ?(
              //   <button
              //     className="button xs"
              //     onClick={() => handleTransferClick(item)}
              //   >
              //     {t("Transfer")}
              //   </button>
              // ):null} */}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default DisassembleTiles;



//             {DisassembleData && DisassembleData.map((item, index) => (
//                 <div className="disassemble-tiles" key={index}>
//                     <div className="d-flex gap-3 gap-xxl-2 justify-content-center">
//                         <div className="disassemble-tiles-text">
//                             <p>Order No</p>
//                             <p>Item Code</p>
//                             <p>No of Coils</p>
//                         </div>
//                         <div className="query-data">
//                             <p>{item.disassemble_No}</p>
//                             <p>{item.item_Code}</p>
//                             <p>{item.no_Of_Coils}</p>
//                         </div>
//                     </div>
//                     {/* Completed Sticker */}
//                     {item.receiptQty >= item.plannedQty && (
//                         <div className="completed-sticker">
//                             <span>Completed <FaCheckCircle size={14} color="white" /></span>
//                         </div>
//                     )}
//                     {/* <div className="disassemble-tiles-text">
//                         <p>Disassemble Order No</p>
//                         <p className="query-data">{item.disassemble_No}</p>
//                     </div>
//                     <div className="disassemble-tiles-text">
//                         <p>Item Code</p>
//                         <p className="query-data">{item.item_Code}</p>
//                     </div>
//                     <div className="disassemble-tiles-text">
//                         <p>Requried Coils</p>
//                         <p className="query-data">{item.no_Of_Coils}</p>
//                     </div> /
//                     <div className="disassemble-tiles-btn">
//                         <button className="button xs" onClick={() => handleTransferClick(item)}>Transfer</button>
//                         <button className="button xs" onClick={() => handleReceiptClick(item)}>Receipt</button>
//                     </div>
//                 </div>
//             ))}
//         </div>
//     );
// }; 